import React from 'react';
import {
  IStackItemStyles,
  IStackStyles,
  IStackTokens,
  Label,
  Link,
  mergeStyleSets,
  registerIcons,
  Stack,
  TextField,
} from '@fluentui/react';
import i18n from '../../../i18n';
import { SvgIcons } from '../../shared/svgIcons/svgIcons';
import { store } from '../../../index';
import { formatwithoutTime } from '../../shared/util';
import { uPrinceTheme } from '../../../theme';

registerIcons(SvgIcons);

const classNames = mergeStyleSets({

  fullWidth: { width: '100%' },
  halfWidth: { width: '49%' },
});

const stackStyles: IStackStyles = { root: { padding: 0, marginBottom: 10 } };

const stackItemStyles: IStackItemStyles = {
  root: {
    display: 'flex',
    height: 50,
    width: 0,
    flexGrow: 1,
  },
};

const stackTokens: IStackTokens = {
  childrenGap: 10,
  padding: 10,
};

const styles = {
  textField: {
    color: uPrinceTheme.palette.themePrimary,
  },
};

const  RfqDelivery=()=>{
  const {rfqFormData}=store.getState()?.po;

  return (
    <div>

      <div className={'card-header'}>
        <Link href="#" id="invoice-invoice-amount">
          <Label>3. {i18n.t('deliveryDetails')} </Label>
        </Link>
      </div>
      <div className={'card-body'}>
        <div className="proj-detail-content inner">

          <div className="marginTop">
            <Stack
              horizontal
              wrap
              styles={stackStyles}
              tokens={stackTokens}
            >
              <Stack.Item grow={6} styles={stackItemStyles}>
                <div className={`${classNames.fullWidth}`}>
                  <TextField
                    value={rfqFormData?.mapLocation?rfqFormData?.mapLocation?.address?.freeformAddress:''}
                    label={i18n.t('deliveryAddress')}
                    disabled={true}
                    style={styles.textField}
                  />
                </div>
              </Stack.Item>
            </Stack>
          </div>

          <div className="marginTop">
            <Stack
              horizontal
              wrap
              styles={stackStyles}
              tokens={stackTokens}
            >
              <Stack.Item grow={6} styles={stackItemStyles}>
                <div className={`${classNames.fullWidth}`}>
                  <TextField
                    value={rfqFormData?.deliveryDate?formatwithoutTime(rfqFormData?.deliveryDate):''}
                    label={i18n.t('requestedDate')}
                    disabled={true}
                    style={styles.textField}
                  />
                </div>
              </Stack.Item>
            </Stack>
          </div>
        </div>
      </div>

      <div className={'card-footer'}>
        <br/>
      </div>

    </div>
  );
};

export default RfqDelivery;
